<mat-calendar
   [id]="dateTimePicker.id"
   [ngClass]="dateTimePicker.panelClass"
   [startAt]="dateTimePicker.startAt"
   [startView]="dateTimePicker.startView"
   [minDate]="dateTimePicker.minDate"
   [maxDate]="dateTimePicker.maxDate"
   [dateFilter]="dateTimePicker.dateFilter"
   [headerComponent]="dateTimePicker.calendarHeaderComponent"
   [selected]="dateTimePicker.selected"
   [dateClass]="dateTimePicker.dateClass"
   [@fadeInCalendar]="'enter'"
   (selectedChange)="dateTimePicker.select($event)"
   (yearSelected)="dateTimePicker.emitYearSelected($event)"
   (monthSelected)="dateTimePicker.emitMonthSelected($event)"
   (_userSelection)="dateTimePicker.close()"
>
</mat-calendar>

<mat-divider></mat-divider>

<lcs-time-picker [startAt]="dateTimePicker.startAt" (selectedChange)="dateTimePicker.select($event)"></lcs-time-picker>
